import React from "react";
import { FormattedMessage } from "react-intl";
import { Row, Space, Button, Badge } from "@masterteam/mt-design-react";

import useIsAr from "../../../Hooks/useIsAr";
import KPIStatusIndicator from "../../KPIStatusIndicator";
import KPIUpdateIndicator from "../../KPIUpdateIndicator";
import { getKPITypeStatusColor } from "../../../helpers";

import "./style.scss";

function Header({
  navItems,
  KPIDetails: {
    ArabicName,
    EnglishName,
    KPIType,
    Status,
    Code,
    RequireUpdate,
    HasNoTarget,
    HasNoBaseline,
    Objective
  },
  setComponentIndex,
  componentIndex
}) {
  const [isAr] = useIsAr();
  const HasNoTargetBaseline = HasNoTarget || HasNoBaseline;

  const statuses =
    +Objective?.Level === 1
      ? KPIType.Status?.filter((s) => s.Code !== "NA")
      : KPIType.Status;

  return (
    <Space direction="vertical" size="large" className="kpi-header">
      <Row size="medium" align="center" className="nav-header-section">
        <div
          className={`kpi-header_title-section ${
            RequireUpdate ? "req-animation" : ""
          }`}
          style={{
            backgroundColor: HasNoTargetBaseline
              ? getKPITypeStatusColor(KPIType.Status, Status)
              : getKPITypeStatusColor(KPIType.Status, Status)
          }}
        >
          <p>{isAr ? ArabicName : EnglishName}</p>
          <div>
            <FormattedMessage id="kpi.code" />: {Code}
          </div>
        </div>

        <Space className="kpi-header_nav">
          {navItems.map((_item, _index) => (
            <div>
              <Button
                variant={componentIndex === _index ? "primary" : "dark"}
                shape="circle"
                size="large"
                loading={_item.loading}
                Icon={_item.Icon}
                onClick={() => setComponentIndex(_index)}
                title={_item?.hoverText && _item?.hoverText}
              />
              {_item.showCounts && _item.counts > 0 && (
                <Badge variant="error" shape="square" className="couts">
                  {_item.counts}
                </Badge>
              )}
            </div>
          ))}
        </Space>
      </Row>
      {componentIndex === 0 ? (
        <Row justify="end" align="unset" size="medium">
          <Space size="medium">
            <KPIUpdateIndicator item={{ RequireUpdate: false }} />
            <KPIUpdateIndicator item={{ RequireUpdate: true }} />
          </Space>
          <div className="kpi-line" />
          <Space size="medium">
            {statuses.map((_item) => (
              <KPIStatusIndicator
                item={_item}
                list={statuses}
                showCalculation
              />
            ))}
          </Space>
        </Row>
      ) : null}
    </Space>
  );
}

export default Header;
